import { ReactNode, useContext } from 'react'

import { StringsContext } from '@lib/strings'
import { CartContext } from '@lib/cart'

import Button, { ButtonProps, ButtonSize } from '@components/buttons/button'

interface ProductAddProps {
  onClick: () => void
  className?: string
  children: ReactNode
}

const ProductAdd = ({
  onClick,
  variant,
  color,
  size = ButtonSize.NORMAL,
  icon,
  className,
  children,
}: ProductAddProps & ButtonProps) => {
  const strings = useContext(StringsContext)
  const { cart, isCartProductAdding } = useContext(CartContext)

  return (
    <Button
      id="product-add-to-cart-button"
      className={className}
      variant={variant}
      color={color}
      size={size}
      icon={icon}
      disabled={!cart || isCartProductAdding}
      onClick={onClick}
    >
      {!cart && strings.buttonUnavailable}
      {isCartProductAdding && strings.buttonAdding}
      {cart && !isCartProductAdding && children}
    </Button>
  )
}

export default ProductAdd
